import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/image/icon/d2.png")